export default "__VITE_ASSET__IsL2QAn7__"